import { Tooltip } from 'antd'
import classNames from 'classnames'
import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react'
import { BeatLoader } from 'react-spinners'
import Colors from '~/app/lib/colors'
import Icon from '../Icon'
import { IconNames } from '../Icon/Icon.type'
import styles from './Button.module.scss'

interface ButtonProps
  extends Omit<
    DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'type'
  > {
  type?: 'solid' | 'filled' | 'outline' | 'borderless' | 'icon'
  variant?: 'primary' | 'secondary' | 'danger' | 'tertiary'
  htmlType?: 'button' | 'submit' | 'reset'
  loading?: boolean
  icon?: IconNames
  iconColor?: string
  tooltip?: string
  shape?: 'normal' | 'square'
  reverse?: boolean
  labelClassname?: string
  iconSize?: number
}

const Button: FC<ButtonProps> = ({
  type = 'solid',
  children,
  className,
  htmlType,
  loading,
  disabled,
  variant = 'primary',
  icon,
  iconColor,
  tooltip,
  shape,
  reverse,
  labelClassname,
  iconSize = 20,
  ...rest
}) => {
  return (
    <Tooltip rootClassName="custom-tooltip" title={tooltip}>
      <button
        className={classNames(
          styles.btn,
          styles[type],
          styles[variant],
          styles[shape as 'normal' | 'square'],
          className,
          {
            [styles.disabled]: loading || disabled,
          }
        )}
        disabled={loading || disabled}
        type={htmlType}
        {...rest}
      >
        {loading ? (
          <BeatLoader
            color={
              type === 'outline' || type === 'borderless'
                ? variant === 'danger'
                  ? Colors.ACCENT_RED
                  : Colors.PRIMARY
                : 'white'
            }
            size={8}
          />
        ) : (
          <div
            className={classNames('flex items-center gap-2', labelClassname, {
              'flex-row-reverse': reverse,
            })}
          >
            {icon && <Icon name={icon} size={iconSize} color={iconColor} />}
            {children}
          </div>
        )}
      </button>
    </Tooltip>
  )
}

export default Button
